import React from 'react';
import { PropTypes } from 'prop-types';

const InitialComponent = ({ width, height }) => (
  <rect
    data-testid="SkeletonLoader__InitialComponent"
    x="0"
    y="0"
    rx="5"
    ry="5"
    width={width}
    height={height}
  />
);

InitialComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

InitialComponent.defaultProps = {
  height: 130,
  width: 400,
};

export default InitialComponent;
